import React from "react";
import { Button, Radio, Select, TextField } from "components";
import { useExemptionsContext } from "../../ExemptionsContext";
import ButtonV2 from "elements/ButtonV2";
import formatDate from "utils/formatDate";
import { isValidDate } from "utils/validDate";

const Portability = () => {
	const {
		flowId,
		next,
		previousAddressValue,
		specialFieldsValue,
		setSpecialFieldsValue,
	} = useExemptionsContext();

	const handleSubmit = async () => {
		next();
	};

	const btnDisabled = React.useMemo(() => {
		return specialFieldsValue?.us_citizen === undefined;
	}, [specialFieldsValue]);

	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				handleSubmit();
			}}>
			<div className="property-profile-question-card">
				<div className="property-profile-question-card-top">
					<div className="property-profile-question-card-title-container">
						<p>Are all property owners US citizens?</p>
						<div className="property-profile-question-card-radio">
							<Radio
								name="usCitizen"
								checked={specialFieldsValue?.us_citizen === true}
								onChange={e => {
									setSpecialFieldsValue({
										us_citizen: true,
									});
								}}
								value="Yes"
								label="Yes"
							/>
							<Radio
								name="usCitizen"
								checked={specialFieldsValue?.us_citizen === false}
								onChange={e => {
									setSpecialFieldsValue({
										us_citizen: false,
									});
								}}
								value="No"
								label="No"
							/>
						</div>
					</div>
				</div>
			</div>
			{specialFieldsValue?.us_citizen === false && (
				<p className="sm exemptions-notification-message-azure">
					At this time we are unable to support non US citizen documentation
					requirements. However, you can still file your own exemption directly
					with the county through the county website.
				</p>
			)}
			<ButtonV2 size="large" disabled={btnDisabled} type="submit">
				Continue
			</ButtonV2>
		</form>
	);
};

export default Portability;
